import { trans } from "../i18n/i18n";

export function generateBrowseReportLinks() {
    const sectionLinks = [
        { selector: "#vin-decoder", text: trans("VIN Decoder") },
        { selector: "#vin-odometer-reading", text: trans("Odometer Reading") },
        { selector: "#vehicle-market-value", text: trans("Vehicle Market Value") },
        { selector: "#stolen-check", text: trans("Stolen Check") },
        { selector: "#wreckers", text: trans("Wreckers") },
        { selector: "#best-deals", text: trans("Best deals") },
    ];

    const browseReportList = document.querySelector(".browse-report-list");
    if (!browseReportList) return;

    sectionLinks.forEach(link => {
        const section = document.querySelector(link.selector);
        if (section) {
            const listItem = document.createElement("li");
            const anchor = document.createElement("a");
            anchor.href = link.selector;
            anchor.textContent = link.text;

            listItem.appendChild(anchor);
            browseReportList.appendChild(listItem);
        }
    });
}

document.addEventListener("DOMContentLoaded", () => {
    generateBrowseReportLinks();
});
